import { BestSeller, OrdersResponse } from "types/orders/orderTypes";
import { apiClient } from "../client";

export const fetchAllOrder = async(id:string):Promise<OrdersResponse> =>{
    const response= await apiClient.get<OrdersResponse>(`/order/admin/orders/foodcourt/${id}`,{
        headers:{
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    });
    return response.data;
 }
 

 export const fetchbestSellingItems = async(id:string):Promise<BestSeller> =>{
    const response= await apiClient.get<BestSeller>(`/order/admin/orders/best_selling_items/${id}`,{
        headers:{
            Authorization: `Bearer ${localStorage.getItem("token")}`
        }
    });
    return response.data;
 }